import { Promise } from "es6-promise";
import { Logger } from "./logger";

export module idb {

	// DB名
	const dbName: string = "postcard";

	// version 
	const version: number = 1.0;

	// storename
	const editStore: string = "editInfo";
	const orderStore: string = "orderInfo";
	const masterStore: string = "masterInfo";


	var _db: IDBDatabase;

	/*
	 * idbの初期化
	 * */
	export function initiDB() :Promise<any>{

		return new Promise((res, rej) => {
			let oprenreq = indexedDB.open(dbName, version);

			// 初回接続時、もしくはバージョン更新時
			oprenreq.onupgradeneeded = function (e) {

				_db = (<IDBRequest>e.target).result;
				_db.createObjectStore(editStore, { keyPath: 'id' });
				_db.createObjectStore(orderStore, { keyPath: 'id' });
				_db.createObjectStore(masterStore, { keyPath: 'id' });

			}

			// 接続成功
			oprenreq.onsuccess = function (e) {
				_db = (<IDBRequest>e.target).result;

				if (!_db.objectStoreNames.contains(editStore)) {
					_db.createObjectStore(editStore, { keyPath: 'id' });
				}
				if (!_db.objectStoreNames.contains(orderStore)) {
					_db.createObjectStore(orderStore, { keyPath: 'id' });
				}
				if (!_db.objectStoreNames.contains(masterStore)) {
					_db.createObjectStore(masterStore, { keyPath: 'id' });
				}
				res("");
			}

			// エラー
			oprenreq.onerror = function (e) {
				Logger.log('idbwrapper 初期化失敗');
				rej("");
			}
		});

		
	}

	/**
	 * データを取得
	 * @param id テーブル名
	 * @param allowNull null許可するか？
	 */
	export function get<T>(id:string,allowNull=false): Promise<T> {

		return new Promise((resolve, reject) => {
			let tx = _db.transaction(id, 'readonly');
			let store = tx.objectStore(id);

			let req = store.get(id);

			req.onsuccess = (e) => {

				let target = (<IDBRequest>e.target);
				try {
					var res = <T>target.result['value'];
					if (res) {
						resolve(res);
					} else {
						Logger.log('idbwrapper データ取得に失敗');
						reject();
					}
				} catch {
					if (allowNull) {
						resolve(null);
					}
					reject();
				}

			}

			req.onerror = (e) => {
				Logger.log('idbwrapper データの取得に失敗');
				reject();
			}
		})
	}

	/**
	 * 削除します。
	 * 
	 * */
	export function del(id:string): Promise<any> {

		return new Promise((resolve, reject) => {
			let tx = _db.transaction(id, 'readwrite');
			let store = tx.objectStore(id);

			let req = store.delete(id);

			req.onsuccess = (e) => {
				resolve("");
			}

			req.onerror = (e) => {
				Logger.log('idbwrapper データの削除に失敗');
				reject();
			}
		})
	}

	/**
	 * editInfoを更新(上書き)します。
	 * 
	 * */
	export function update<T>(id :string,wantUpd:T): Promise<T> {

		return new Promise((resolve, reject) => {
			let tx = _db.transaction(id, 'readwrite');
			let store = tx.objectStore(id);

			// Todo EditInfo Data class
			let data = {
				id: id,
				value: wantUpd
			}

			let req = store.put(data);

			req.onsuccess = (e) => {
				Logger.log('idbwrapper add success.');
				resolve();
			}

			req.onerror = (e) => {
				Logger.log('idbwrapper add error.');
				reject();
			}
		})
	}
}